// Chat Store
import { getField, updateField } from 'vuex-map-fields'
import { chat as chatPlugin } from '@/plugins/chat'

const state = {
  isOpen: false,
  conversation: null,
  conversationId: null,
  selectedPanel: 'ChatConversations',
  unread: 0,
  reloadConversations: false,
  reloadUnread: false,
}

const getters = {
  getField,
}

const actions = {
  chat() {
    return chatPlugin(this._actions['chat/handleMessage'][0])
  },
  handleMessage({ commit, state }, data) {
    if (
      state.selectedPanel === 'ChatConversation' &&
      state.conversation &&
      state.conversation.id === data.id &&
      data.message
    ) {
      commit('PUSH_TO_CONVERSATION_MESSAGES', data.message)
    } else if (state.selectedPanel === 'ChatConversations') {
      commit('RELOAD_CONVERSATIONS')
    }
    commit('RELOAD_UNREAD')
  },
  toggleOpen({ commit }) {
    commit('TOGGLE_OPEN')
  },
  setConversation({ commit }, val) {
    commit('SET_CONVERSATION', val)
  },
  setOpen({ commit }, val) {
    commit('SET_OPEN', val)
  },
  setSelectedPanel({ commit }, val) {
    commit('SET_SELECTED_PANEL', val)
  },
}

const mutations = {
  TOGGLE_OPEN: state => {
    state.isOpen = !state.isOpen
  },
  PUSH_TO_CONVERSATION_MESSAGES: (state, val) => {
    state.conversation.messages.push(val)
  },
  RELOAD_CONVERSATIONS: state => {
    state.reloadConversations = true
  },
  RELOAD_UNREAD: state => {
    state.reloadUnread = true
  },
  SET_CONVERSATION: (state, val) => {
    state.conversation = val
  },
  SET_OPEN: (state, val) => {
    state.isOpen = val
  },
  SET_SELECTED_PANEL: (state, val) => {
    state.selectedPanel = val
  },
  updateField,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
